import { getAxiosInstance } from "../ApiConfig";

async function getAllSharedReportUserPermission(userId, sharingType, sharingIds) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedReportUserPermission/${userId}/${sharingType}/${sharingIds}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}

async function getShareById(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByShareId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}

async function createSharing(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createSharing`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}

async function updateSharing(id, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateSharing/${id}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}

async function deleteSharing(id) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteSharing/${id}`);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}

export {
    getAllSharedReportUserPermission,
    getShareById,
    createSharing,
    updateSharing,
    deleteSharing
}
